import { render, staticRenderFns } from "./tengoAgua_View.vue?vue&type=template&id=4e34ec9b&scoped=true&"
import script from "./tengoAgua_View.vue?vue&type=script&lang=js&"
export * from "./tengoAgua_View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e34ec9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VForm,VSelect})
